import { TThemeColorScheme } from '../types';

/**
 * In any case `companyId` is not set in the env or later in the platformId
 * We should fallback to using northladder as the default company.
 * This is to ensure that the app can still function without a specific
 * company configuration.
 */
export const FALLBACK_COMPANY_ID = 'northladder';
/**
 * Fallback color scheme in case the company configuration is not set
 * or the color scheme is not set in the company configuration.
 * This is used to ensure that the app has a default color scheme to use.
 */
export const FALLBACK_COLOR_SCHEME: TThemeColorScheme = 'purple-scheme';
